import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExitComponent } from './exit.component';
import { TooltipModule } from 'primeng/tooltip';



@NgModule({
  imports: [
    CommonModule,
    TooltipModule
  ],
  exports: [
    ExitComponent
  ],
  declarations: [
    ExitComponent
  ],
})
export class ExitModule { }